// store.js
import Vue from "vue"
import Vuex from "vuex" //引入vuex
Vue.use(Vuex) //使用vuex
 
export default new Vuex.Store({
    state:{
		secretarylength: 0,
		emodate:0,
		noiseList:[],
		trainList:[]
    },
    mutations:{
		addSecretary(state,vla){
			state.secretarylength+=vla;
		},
		rmSecretary(state){
			state.secretarylength=0;
		},
		setEmodate(state){
			state.emodate=1;
		},
		rmEmodate(state){
			state.emodate=0;
		},
		setNoise(state,vla){
			state.noiseList=vla;
		},
		setTrain(state,vla){
			state.trainList=vla;
		}
    },
    actions:{
 
    },
    modules:{
 
    }
})